<template>
  <div class="calico-document-item">
    <CalicoDocumentListItem 
      v-if="!editing" 
      :year="document.year" 
      :filename="document.name" 
      :description="document.description"
      :editable="editable"
      @edit="edit"
      @delete="$emit('delete', document)"
      @download="$emit('download', document)"
    />
    <CalicoDocumentUploadInline 
      v-else 
      :document="document" 
      @save="save" 
      @cancel="cancel" 
    />
  </div>
</template>

<script>
import CalicoDocumentListItem from '@/components/calico/documentListItem/index.vue'
import CalicoDocumentUploadInline from '@/components/calico/documentUploadInline/index.vue'

export default {
  name: 'CalicoDocumentItem',
  components: {
    CalicoDocumentListItem,
    CalicoDocumentUploadInline
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    document: {
        type: Object,
        default: () => ({
            name: "",
            type: "",
            size: 0,
            year: "",
            description: ""
        })
    },
  },
  emits: ['save', 'cancel', 'edit', 'delete', 'download'],
  data () {
    return {
        editing: false
    }
  },
  methods: {
    save (document) {
      this.editing = false
      this.$emit('save', document)
    },
    cancel (document) {
      this.editing = false
      this.$emit('cancel', document)
    },
    edit () {
      this.editing = true
      this.$emit('edit', this.document)
    }
  }
}
</script>

<style lang="scss">
.calico-document-item {
    width: 100%;
}
</style>
